module.exports = __webpack_public_path__ + "static/media/25542430_1703513379723846_1577589457878250669_o.b96427a7.jpg";